module.exports = __webpack_public_path__ + "static/media/s1.882312c5.jpg";